<template>
  <div class="p_pro_content">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>小杰闪查</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/bgSet' }">闪查管理</el-breadcrumb-item>
          <el-breadcrumb-item>新建客户</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_pro_table" v-loading="listLoading">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="客户信息" name="first"></el-tab-pane>
          <el-tab-pane label="项目信息" name="second" :disabled="isCanChange"></el-tab-pane>
        </el-tabs>
        <el-form v-if="activeName == 'first'" :model="custQuery" :rules="custrules" :inline="true" ref="custForm" class="pro-form-inline add_form" label-width="120px">
          <el-form-item label="客户名称:" prop="strCustName">
            <el-autocomplete style="width:300px;" value-key="StrCustName" v-model="custQuery.strCustName" :disabled="isDetail" clearable :fetch-suggestions="queryCustSearch" placeholder="" @select="handleSelectCust"></el-autocomplete>
            <!-- <el-input v-model="custQuery.strCustName" :disabled="isDetail" clearable placeholder=""></el-input> -->
          </el-form-item>
          <el-form-item label="客户简称:">
            <el-input v-model="custQuery.strCustShortName" :disabled="isDetail" clearable placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="所属集团名称:">
            <el-input v-model="custQuery.strGroupName" :disabled="isDetail" clearable placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="客户等级:">
            <el-select v-model="custQuery.strCustlevel" clearable :disabled="isDetail" placeholder="">
                <el-option
                    v-for="(item,index) in levelList"
                    :key="'d'+index"
                    :label="item.StrCustprolevelName"
                    :value="item.Custprolevelid">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="地区:">
            <el-cascader :props="propsAddress" filterable ref="cascaderArr" placeholder="" :disabled="isDetail" v-model="selectedCust" :options="areaList" @change="changeCustAreaHandle"></el-cascader>
          </el-form-item>
          <el-form-item label="客户类别:">
            <el-select v-model="custQuery.strCustType" filterable clearable placeholder="" :disabled="isDetail" @change="industryChange">
              <el-option
                  v-for="(item,index) in industryList"
                  :key="'e'+index"
                  :label="item.StrCustindustName"
                  :value="item.Custindustid">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户行业:">
            <el-select v-model="custQuery.strCustindust" clearable filterable placeholder="" :disabled="isDetail" @change="industryNameChange">
              <el-option
                  v-for="(item,index) in industryNameList"
                  :key="'f'+index"
                  :label="item.StrCustindustName"
                  :value="item.Custindustid">
                </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="业务员部门:">
            <el-cascader ref="cascaderArr"
                v-model="depForm.strBusidepList" :props="props" :disabled="isDetail" clearable filterable
                :options="departmentList" placeholder=""
                @change="depChange($event)"></el-cascader>
          </el-form-item>
          <el-form-item label="业务员:">
            <el-select filterable
                  v-model="depForm.strsaleuserid" :disabled="isDetail" clearable
                  placeholder="" @change="salesChange"
                >
                  <el-option
                    v-for="(item,index) in salesmanList"
                    :key="'g'+index"
                    :label="item.Username"
                    :value="item.Userid">
                  </el-option>
                </el-select>
          </el-form-item> -->
          <div class="btnbox">
            <!-- <el-button @click="backHandle" size="small">返回</el-button> -->
            <el-button type="primary" size="small" :loading="nextLoading" @click="nextStep">下一步</el-button>
          </div>
        </el-form>
        <el-form v-if="activeName == 'second'" :model="proForm" :rules="rules" :inline="true" ref="proForm" class="pro-form-inline add_form" label-width="120px">
          <el-form-item label="项目名称:" prop="strprojectName">
            <el-autocomplete style="width:300px;" value-key="StrprojectName" v-model="proForm.strprojectName" :disabled="isDetail" clearable :fetch-suggestions="querySearch" placeholder="请输入项目名称" @select="handleSelect"></el-autocomplete>
          </el-form-item>
          <el-form-item label="立项时间:" prop="dtInitDate">
            <el-date-picker type="date" clearable value-format="yyyy-MM-dd" placeholder="请选择立项时间" v-model="proForm.dtInitDate" :disabled="isDetail"></el-date-picker>
          </el-form-item>
          <el-form-item label="客户名称:" prop="custid">
            <el-select v-model="proForm.custid" disabled filterable clearable placeholder="请选择客户名称">
              <el-option v-for="(item, index) in customList" :key="index" :label="item.StrCustName" :value="item.Custid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目等级:" prop="strprojectlevel">
            <el-select v-model="proForm.strprojectlevel" placeholder="请选择项目等级" clearable :disabled="isDetail">
              <el-option v-for="(item, index) in levelList" :key="index" :label="item.StrCustprolevelName" :value="item.Custprolevelid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="实操业务类型:" prop="actualtype">
            <el-select v-model="proForm.actualtype" filterable placeholder="请选择实际操作业务类型" clearable :disabled="true">
              <el-option v-for="(item, index) in businessList" :key="index" :label="item.StrBusitypeName" :value="item.Busitypeid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在地区:" prop="entNation" class="pro_area">
            <el-cascader :props="propsAddress" filterable ref="cascaderArr" placeholder="" :disabled="isDetail" v-model="selected" :options="areaList" @change="changeAreaHandle"></el-cascader>
          </el-form-item>
          <el-form-item label="业绩归属部门:" prop="strbusdep">
            <el-cascader v-model="perDepartList" :disabled="isDetail" :props="props" clearable filterable :options="departList" placeholder="请选择业绩归属部门" @change="perSectionChange"></el-cascader>
          </el-form-item>
          <el-form-item label="业务团队长:" prop="strpartner">
            <el-select v-model="proForm.strpartner" filterable clearable @change="partnerSelChange" placeholder="请选择业务团队长" :disabled="isDetail">
              <el-option v-for="(item, index) in leaderList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业绩归属人部门:" prop="strAchievedep">
            <el-cascader v-model="perOwnerList" :disabled="isDetail" :props="props" clearable filterable :options="departList" placeholder="请选择业绩归属人部门" @change="ownerSectionChange"></el-cascader>
          </el-form-item>
          <el-form-item label="业绩归属人:" prop="strAchieveowner">
            <el-select v-model="proForm.strAchieveowner" filterable clearable @change="achieveownerChange" placeholder="请选择业绩归属人" :disabled="isDetail">
              <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务部门:">
            <el-cascader v-model="dedpartNameList" :disabled="isDetail" :props="props" clearable filterable :options="departList" placeholder="请选择服务部门" @change="handleSectionChange"></el-cascader>
          </el-form-item>
          <el-form-item label="客服:" prop="editCusIds">
            <el-select v-model="proForm.editCusIds" filterable clearable multiple placeholder="请选择客服" :disabled="isDetail" @change="servuserChange">
              <el-option v-for="(item, index) in customerList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合伙人:" prop="strpartner2">
            <el-select v-model="proForm.strpartner2" filterable clearable placeholder="请选择合伙人" :disabled="isDetail" @change="strpartner2Change">
              <el-option v-for="(item, index) in partnerList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目管理员:" prop="strProManager">
            <el-select v-model="proForm.strProManager" filterable clearable placeholder="请选择项目管理员" :disabled="isDetail" @change="proManagerChange">
              <el-option v-for="(item, index) in staffList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票类型:" prop="strBillmethod">
            <el-select v-model="proForm.strBillmethod" placeholder="请选择发票类型" :disabled="isDetail" clearable>
              <el-option label="专票" value="专票"></el-option>
              <el-option label="普票" value="普票"></el-option>
              <el-option label="专票+普票" value="专票+普票"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票方式:" prop="strinvoiceType">
            <el-select v-model="proForm.strinvoiceType" placeholder="请选择开票方式" :disabled="isDetail" clearable>
              <el-option label="全额" value="全额"></el-option>
              <el-option label="差额" value="差额"></el-option>
              <el-option label="全额+差额" value="全额+差额"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票内容:" prop="strInvoicecontent">
            <el-input v-model="proForm.strInvoicecontent" :disabled="isDetail" clearable placeholder="请输入开票内容"></el-input>
          </el-form-item>
          <el-form-item label="是否垫资:" prop="isAdvMoney">
            <el-select v-model="proForm.isAdvMoney" placeholder="请选择是否垫资" :disabled="isDetail" clearable>
              <el-option label="垫支" value="垫支"></el-option>
              <el-option label="不垫支" value="不垫支"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签约主体:" prop="strSignsubject">
            <el-select v-model="proForm.strSignsubject" filterable placeholder="请选择签约主体" :disabled="isDetail" clearable>
              <el-option v-for="(item, index) in legalList" :key="index" :label="item.StrLegalsubName" :value="item.Legalsubid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同业务类型:" prop="strContractType">
            <el-select v-model="proForm.strContractType" filterable placeholder="请选择合同业务类型" :disabled="isDetail" clearable>
              <el-option v-for="(item, index) in businessList" :key="index" :label="item.StrBusitypeName" :value="item.Busitypeid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同起始时间:" prop="dtContractstartDate">
            <el-date-picker type="date" clearable value-format="yyyy-MM-dd" placeholder="请选择合同起始时间" v-model="proForm.dtContractstartDate" :disabled="isDetail"></el-date-picker>
          </el-form-item>
          <el-form-item label="合同到期时间:" prop="dtContractendDate">
            <el-date-picker type="date" clearable value-format="yyyy-MM-dd" placeholder="请选择合同到期时间" v-model="proForm.dtContractendDate" :disabled="isDetail"></el-date-picker>
          </el-form-item>
          <el-form-item label="合同负责人:" prop="strContleader">
            <el-select v-model="proForm.strContleader" filterable clearable placeholder="请选择合同负责人" :disabled="isDetail" @change="contleaderChange">
              <el-option v-for="(item, index) in staffList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目查看人:" prop="strViewids">
            <el-select v-model="viewidList" filterable clearable multiple placeholder="请选择项目查看人" :disabled="isDetail" @change="$forceUpdate()">
              <el-option v-for="(item, index) in viewsList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="btnbox">
            <el-button @click="backHandlePrev" size="small">返回</el-button>
            <el-button type="primary" @click="submitForm('proForm')" size="small" :disabled="isDetail">保存</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import xz from "@/common";
export default {
  name: "serviceCenter",
  data() {
    return {
      listLoading: false,
      isCanChange:true,
      // 选中的负责客服人员列表
      selServiceList: [],
      isDetail: false,
      nextLoading:false,
      pageTitle: "新增项目",
      // 项目名称列表
      proNameList: [],
      // 项目名称列表参数
      proNameQuery: {
        projectname: "", // 项目名称
        projectid: "", // 项目id
        custname: "", //客户名称
        strAchieveowner: "", // 业绩归属人
        strservuserid: "", // 客服
        strBusiStat: "", //项目状态
        strpartner2: "", //合伙人
        perpage: 100000000,
        currpage: 1,
        strorgancode: "",
        roletype: "",
      },
      // 项目等级列表
      levelList: [],
      // 实操业务类型列表
      businessList: [],
      // 业绩归属部门列表
      belongList: [],
      // 业绩归属子部门列表
      belongChildList: [],
      // 业务团队长列表
      leaderList: [],
      // 客服列表
      customerList: [],
      // 业绩归属人列表
      belongOwnerList: [],
      // 客服列表
      cusServiceList: [],
      // 员工列表
      staffList: [],
      // 合伙人
      partnerList: [],
      // 项目管理员列表
      adminList: [],
      // 业绩归属人
      memberList: [],
      // 项目查看人列表
      viewsList: [],
      // 部门列表
      departList: [],
      // 多级部门列表
      sectionList: [],
      // 选中的多级部门
      dedpartNameList: [],
      // 选中的业绩归属部门
      perDepartList: [],
      // 选中的业绩归属人部门
      perOwnerList: [],
      strCustTypeUpdate:'',
      // 行业类别
      industryList:[],
      // 行业名称
      industryNameList:[],
      // 业务部门
      departmentList:[],
      // 业务员
      salesmanList:[],
      custData:[],//客户列表
      // 发薪日期
      paydateList: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],
      // 法务主体
      legalList: [],
      tableHeight: 0,
      tableLoading: false,
      custrules: {
        strCustName: [
          { required: true, message: "请输入客户名称", trigger: ["change","blur"] }
        ]
      },
      rules: {
        // custid: [
        //   { required: true, message: "请输入客户名称", trigger: "blur" },
        // ],
        strprojectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        dtInitDate: [
          { required: true, message: "请选择立项时间", trigger: "change" },
        ],
        editCusIds: [
          {
            type: "array",
            required: true,
            message: "请选择客服",
            trigger: "change",
          },
        ],
      },
      isEdit: false,
      // 客户列表参数
      listQuery: {
        currpage: 1,
        perpage: 10000000,
        strorgancode: "",
        roletype: "",
        strCustlevel: "", // 客户等级
        strProvince: "", // 省
        strCity: "", // 市
        custname: "", //客户名称
        username: "", //业务员
        depname: "", //业务部门
        groupname: "", //所属集团
        strCustType: "", //客户类别
        strCustindust: "", //客户行业
      },
      // 新增/编辑项目信息参数
      proForm: {
        projectid: "", //项目id
        strprojectName: "", //项目名称
        custid: "", //客户id
        dtInitDate: "", //立项时间
        strSignsubject: "", //签约主体
        strContractType: "", //合同业务类型
        actualtype: "M01013", //业务类型
        strprojectlevel: "", //项目等级
        strProProvince: "", //省
        strProCity: "", //市
        strbusdep: "", //业绩归属部门
        // strbussondep:'', //业绩归属子部门
        strpartner: "", //业务团队长
        strpartner2: "", //合伙人
        strAchieveowner: "", //业绩归属人
        strAchievedep: "", //业绩归属人部门
        strservuserid: "", //客服
        strProManager: "", //项目管理员
        strBusiStat: "合作中", //项目状态
        strrecruit: "", //是否招聘
        strTransfer: "", //是否转移
        strHighRisk: "", //协议高风险
        strNewadd: "", //是否新增
        socialInsurance: "", //社保
        socialInsuranceList: [], //社保多选
        busInsurance: "", //商保
        busInsuranceList: [], //商保多选
        decRiskfund: "", //风险计提金
        strinvoiceType: "", //开票方式
        strInvoicecontent: "", //发票内容
        strBillmethod: "", //发票类型
        dtpaydate: "", //发薪日期
        isAdvMoney: "", //是否垫资
        dtEndDate: "1900-01-01", //项目终止时间
        dtContractstartDate: "", //合同开始时间
        dtContractendDate: "", //合同结束时间
        strContleader: "", //合同负责人
        strDep1: "", //部门一级
        strDep2: "", //部门二级
        strDep3: "", //部门三级
        strRegion: "", //地区码
        editCusIds: [],
        strViewids: "" //项目查看人
      },
      // 选中的查看人
      viewidList: [],
      // 选中的地区code
      selected: [],
      selectedCust:[],
      // 客户列表
      customList: [],
      // 社保
      socialSecurityList: [],
      // 商保
      insuranceList: [],
      // 参数列表参数
      paramQuery: {
        currpage: 1,
        perpage: 100000,
        keyword: "",
        strIsDisable: "1", // 传1 禁用的看不到了  不传就全显示
        // JB_base_Busitype 业务类型 JB_base_Custprolevel客户项目等级
        // JB_base_Jobfunclabel 岗位职能标签 JB_base_Socialsec社保 JB_base_Busisec 商保
        strtableid: "",
      },
      // 客户部门参数
      departCustQuery: {
        strorgancode: "",
        roletype: "",
      },
      // 部门参数
      departQuery: {
        strorgancode: "",
        roletype: "",
      },
      // 部门员工参数
      departCustMemberQuery:{
        currpage: 1,
        perpage: 10000,
        strWorkState:'',
        keyword:''
      },
      // 员工参数
      departMemberQuery: {
        currpage: 1,
        perpage: 10000,
        strWorkState: "在职",
        keyword: "",
      },
      // select是否有改变
      isLeaderChange: false,
      isproManagerChange: false,
      isStrpartner2Change: false,
      isServuserChange: false,
      isAchieveownerChange: false,
      isPartnerSelChange: false,
      // 人员详情的id
      dtlOneQuery: {
        strpartner: "", //业务团队长
        strpartner2: "", //合伙人
        strAchieveowner: "", //业绩归属人
        strservuserid: "", //客服
        strProManager: "", //项目管理员
        strContleader: "", //合同负责人
      },
      // 区域的数据
      areaCityList: [],
      areaProvinceList: [],
      areaList: [],
      propsAddress: {
        label: "Name",
        value: "Name",
        children: "children",
        checkStrictly: true,
      },
      // 自定义 级联选择props
      props: {
        label: "strorganname",
        value: "strorgancode",
        children: "children",
        checkStrictly: true,
      },
      // 行业列表参数
      industryQuery:{
        currpage:1,
        perpage:10000,
        keyword:'',
        strIsDisable:'', // 传1 禁用的看不到了  不传就全显示
        strtabletype:'parent', // parent child(子级要传strtabletypename)
        strtabletypename:''
      },
      // 业务部门员工参数
      oneDepartQuery:{
        strorgancode:'',
        roletype:''
      },
      activeName: "first",
      // 新增客户/项目参数
      custQuery:{
        custid:'',
        strCustShortName:'', // 客户简称
        strCustName:'', // 客户名称
        strGroupName:'', // 所属集团
        strCustlevel:'', // 客户等级
        strCustindust:'', // 行业名称 客户行业
        strCustType:'', // 行业分类 客户类别
        strProvince:'', // 省
        strCity:'', // 市
        strRegion: '', // 地区码
        strBusidepList:[]
      },
      // 新增/编辑业务员/业务部门
      depForm:{
        strorganname:'',//业务部门
        username:'',//业务员
        strBusidepList:[], //选中的业务部门id
        strBusidep:'', //业务部门id
        strsaleuserid:'' //业务员id
      },
      azList:[],
      // 新人员列表
      memberComQuery: {
        currpage: 1,
        perpage: 10000000,
        keyword: "",
        strWorkState: "在职",
        strstation: "",
        strorgancode: ""
      }
    };
  },
  created() {
    this.getprovinces();
    this.areaCityList = this.$store.state.city;
    this.areaProvinceList = this.$store.state.province;
    this.proNameQuery.roletype = localStorage.loginRoletype;
    this.proNameQuery.strorgancode = localStorage.gancode;
    this.listQuery.roletype = localStorage.loginRoletype;
    this.listQuery.strorgancode = localStorage.gancode;
    // this.isEdit = this.$route.query.isEdit;
    if (this.isEdit == "true") {
      this.pageTitle = "编辑项目";
      this.proForm.projectid = this.$route.query.projectid;
      this.getDetailData();
      this.isDetail = false;
    } else if (this.isEdit == "false"||this.isEdit == false) {
      this.pageTitle = "新增项目";
      this.isDetail = false;
      // 部门
      this.getDepartList();
    } else if (this.isEdit == "detail") {
      this.pageTitle = "项目详情";
      this.proForm.projectid = this.$route.query.projectid;
      this.getDetailData();
      this.isDetail = true;
    }
    // 客户列表
    this.getCusList()
    this.getCustListAll()
    this.getCustDepartList()
    this.getMemberList2()
    this.getIndustryTypeList()
    // 客户项目等级
    this.getParamList("JB_base_Custprolevel");
  },
  methods: {
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
    },
    // 选择客户地址
    changeCustAreaHandle(val){
      if(!this.isNull(val)){
          // const checkedNode =  this.$refs["cascaderArr"].getCheckedNodes();
          // let labels = checkedNode[0].pathLabels
          if(val.length == 2 || val.length > 2){
            this.custQuery.strProvince = val[0]
            this.custQuery.strCity = val[1]
          }
          if(val.length == 1){
            this.custQuery.strProvince = val[0]
          }
      }else{
        this.custQuery.strProvince = ''
        this.custQuery.strCity = ''
      }
      this.custQuery.strRegion = val.toString()
    },
    //选择地址
    changeAreaHandle(val) {
      // console.log('ddd', val)
      if (!this.isNull(val)) {
        // const checkedNode =  this.$refs["cascaderArr"].getCheckedNodes();
        // let labels = checkedNode[0].pathLabels
        if (val.length == 2 || val.length > 2) {
          this.proForm.strProProvince = val[0];
          this.proForm.strProCity = val[1];
        }
        if (val.length == 1) {
          this.proForm.strProProvince = val[0];
        }
      } else {
        this.proForm.strProProvince = "";
        this.proForm.strProCity = "";
      }
      this.proForm.strRegion = val.toString();
    },
    //获取省市区
    getprovinces() {
      xz.getAreaAll().then((res) => {
        // console.log('getprovinces', res)
        this.areaList = res;
        if (!this.isNull(this.areaList)) {
          for (const key in this.areaList) {
            // 删除第三层children属性
            for (const i in this.areaList[key].children) {
              delete this.areaList[key].children[i].children;
            }
          }
        }
        if (this.isEdit == "true" || this.isEdit == "detail") {
          // 匹配省市
          let areaVal = "";
          if (!this.isNull(this.proForm.strProProvince)) {
            if (!this.isNull(this.proForm.strProCity)) {
              areaVal = this.proForm.strProCity;
            } else {
              areaVal = this.proForm.strProProvince;
            }
          } else {
            if (!this.isNull(this.proForm.strProCity)) {
              areaVal = this.proForm.strProCity;
            }
          }
          let posArrVal = this.getParentsByName(this.areaList, areaVal);
          // console.log('99',this.areaList,posArrVal)
          if (!this.isNull(posArrVal)) {
            if (posArrVal.length > 1) {
              this.selected = [posArrVal[1].Name, posArrVal[0].Name];
            } else if (posArrVal.length == 1) {
              this.selected = [posArrVal[0].Name];
            }
          }
        }
      });
    },
    //根据targetName查询该节点和所有父级节点 回显el-cascader组件的值
    getParentsByName(list, targetName) {
      for (let i in list) {
        if (list[i].Name.indexOf(targetName) > -1) {
          //查询到就返回该数组对象
          return [list[i]];
        }
        if (list[i].children) {
          let node = this.getParentsByName(list[i].children, targetName);
          if (node !== undefined) {
            //查询到把父节点连起来
            return node.concat(list[i]);
          }
        }
      }
    },
    //确定保存
    submitForm(formName) {
      if (this.isLeaderChange == false) {
        this.proForm.strContleader = this.dtlOneQuery.strContleader;
      }
      if (this.isproManagerChange == false) {
        this.proForm.strProManager = this.dtlOneQuery.strProManager;
      }
      if (this.isStrpartner2Change == false) {
        this.proForm.strpartner2 = this.dtlOneQuery.strpartner2;
      }
      if (this.isServuserChange == false) {
        this.proForm.strservuserid = this.dtlOneQuery.strservuserid;
      }
      if (this.isAchieveownerChange == false) {
        this.proForm.strAchieveowner = this.dtlOneQuery.strAchieveowner;
      }
      if (this.isPartnerSelChange == false) {
        this.proForm.strpartner = this.dtlOneQuery.strpartner;
      }
      if (this.proForm.busInsuranceList) {
        this.proForm.busInsurance = this.proForm.busInsuranceList.toString();
      }
      if (this.proForm.socialInsuranceList) {
        this.proForm.socialInsurance =
          this.proForm.socialInsuranceList.toString();
      }
      if (this.viewidList) {
        this.proForm.strViewids = this.viewidList.toString();
      }
      if(this.proForm.strprojectName!=undefined && this.proForm.strprojectName.indexOf('背调')==-1){
        this.proForm.strprojectName = '背调-' + this.proForm.strprojectName
      }
      // console.log('submitForm',this.proForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          xz.BSaveJbProject(this.proForm).then((res) => {
            if (res.status == "ok") {
              this.saveCustAndPro()
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 保存新增的客户和项目
    saveCustAndPro(){
      let query = {
        custid: this.proForm.custid,
        strCustShortName: this.custQuery.strCustShortName,
        strCustName: this.custQuery.strCustName,
        strGroupName: this.custQuery.strGroupName,
        ProjectName: this.proForm.strprojectName
      }
      // console.log('fff',query)
      xz.createcustomer(query).then((res) => {
        if (res.status == "ok") {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.$router.push({
            path: "/bgSet",
          });
        } else {
          this.$message({
            message: "保存失败，请稍后再试",
            type: "error",
          });
        }
      });
    },
    // 查找出城市对应码
    getCityCode(data, val) {
      // console.log('lll',data)
      let cityArr = data.filter((element) => element.name == val + "市");
      return cityArr;
    },
    // 合同负责人change
    contleaderChange(val) {
      // console.log('select改变', val)
      this.isLeaderChange = true;
    },
    // 项目管理员
    proManagerChange(val) {
      if (this.isNull(val)) {
        this.dtlOneQuery.strProManager = "";
      }
      this.isproManagerChange = true;
    },
    // 合伙人
    strpartner2Change(val) {
      if (this.isNull(val)) {
        this.dtlOneQuery.strContleader = "";
      }
      this.isStrpartner2Change = true;
    },
    // 客服
    servuserChange(val) {
      if (this.isNull(val)) {
        this.dtlOneQuery.strservuserid = "";
        this.proForm.editCusIds = [];
      } else {
        // 判断是否是登录人员的上下级
        this.rankHandle(val[Number(val.length) - 1]);
        this.dtlOneQuery.strservuserid = val.toString();
      }
      this.isServuserChange = true;
      this.proForm.strservuserid = val.toString();
    },
    // 判断是否是登录人员的上下级
    rankHandle(checkuserid) {
      xz.checkProStrservuserid(checkuserid).then((res) => {
        if (res.status == "ok") {
          if (res.msg == "false") {
            this.selServiceList.push(res.username);
            this.$message({
              type: "warning",
              message:
                "温馨提示:" +
                res.username +
                "客服非您负责区域的客服人员,请确认！",
              center: true,
              duration: 2500,
            });
          }
          this.selServiceList = [...new Set(this.selServiceList)];
        }
      });
    },
    // 业绩归属人
    achieveownerChange(val) {
      if (this.isNull(val)) {
        this.dtlOneQuery.strAchieveowner = "";
      }
      this.isAchieveownerChange = true;
    },
    // 业务团队长
    partnerSelChange(val) {
      if (this.isNull(val)) {
        this.dtlOneQuery.strpartner = "";
      }
      this.isPartnerSelChange = true;
    },
    // 部门选择
    handleSectionChange(value) {
      // console.log(value)
      this.proForm.strservuserid = "";
      if (value.length >= 3) {
        this.proForm.strDep1 = value[0];
        this.proForm.strDep2 = value[1];
        this.proForm.strDep3 = value[2];
      }
      if (value.length == 2) {
        this.proForm.strDep1 = value[0];
        this.proForm.strDep2 = value[1];
        this.proForm.strDep3 = "";
      }
      if (value.length == 1) {
        this.proForm.strDep1 = value[0];
        this.proForm.strDep2 = "";
        this.proForm.strDep3 = "";
      }
      if (this.isNull(value)) {
        this.proForm.strDep1 = "";
        this.proForm.strDep2 = "";
        this.proForm.strDep3 = "";
      }
      // this.departQuery.strorgancode = value[Number(value.length)-1]
      // this.departQuery.roletype = localStorage.loginRoletype
      // this.getCustomerList('customer')
    },
    // 业绩归属部门选择
    perSectionChange(val) {
      // console.log('业绩归属部门', val)
      if (this.isNull(val)) {
        this.proForm.strbusdep = "";
      } else {
        this.proForm.strbusdep = val[Number(val.length) - 1];
      }
    },
    // 业绩归属人部门选择
    ownerSectionChange(val) {
      // console.log('业绩归属人部门', val)
      this.proForm.strAchieveowner = "";
      // this.departQuery.strorgancode = val[Number(val.length)-1]
      // this.departQuery.roletype = localStorage.loginRoletype
      // this.getMemberList('member')
      if (this.isNull(val)) {
        this.proForm.strAchievedep = "";
      } else {
        this.proForm.strAchievedep = val[Number(val.length) - 1];
      }
    },
    // 选择客户名称
    handleSelectCust(item) {
      // console.log(item);
      this.custQuery.custid = item.Custid
      this.getDetailCustData()
    },
    // 选择项目名称
    handleSelect(item) {
      console.log(item);
      this.proForm.projectid = item.Projectid
      this.getDetailData()
    },
    // 修改社保
    socialChange(val) {
      // console.log('kkk', val)
      if (this.isNull(val)) {
        this.$set(this.proForm, this.proForm.socialInsuranceList, []);
        this.$set(this.proForm, this.proForm.socialInsurance, "");
      } else {
        this.$set(this.proForm, this.proForm.socialInsuranceList, val);
        this.$set(this.proForm, this.proForm.socialInsurance, val.toString());
      }
    },
    // 修改商保
    busChange(val) {
      if (this.isNull(val)) {
        this.$set(this.proForm, this.proForm.busInsuranceList, []);
        this.$set(this.proForm, this.proForm.busInsurance, "");
      } else {
        this.$set(this.proForm, this.proForm.busInsuranceList, val);
        this.$set(this.proForm, this.proForm.busInsurance, val.toString());
      }
    },
    // 匹配客户名称
    queryCustSearch(queryString, cb) {
      let proNameLists = this.custData;
      let results = queryString
        ? proNameLists.filter(this.createFilter1(queryString))
        : proNameLists;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter1(queryString) {
      return (res) => {
        return (
          res.StrCustName.toLowerCase().indexOf(
            queryString.toLowerCase()
          ) === 0
        );
      };
    },
    // 匹配项目名称
    querySearch(queryString, cb) {
      let proNameLists = this.proNameList;
      let results = queryString
        ? proNameLists.filter(this.createFilter(queryString))
        : proNameLists;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (res) => {
        return (
          res.StrprojectName.toLowerCase().indexOf(
            queryString.toLowerCase()
          ) === 0
        );
      };
    },
    // 选择区域
    changeArea(datas) {
      // console.log('changeArea', datas)
      // 区域code
      let dataCode = "";
      if (datas.area) {
        dataCode = datas.area.code;
      } else if (datas.city) {
        dataCode = datas.city.code;
      } else {
        dataCode = datas.province.code;
      }
      this.proForm.strProCity = datas.city.name;
      this.proForm.strProProvince = datas.province.name;
      this.proForm.strRegion = dataCode;
    },
    // 返回上一页
    backHandle() {
      this.$router.go(-1);
    },
    backHandlePrev(){
      this.activeName = 'first'
    },
    // 获取客户列表
    getCustListAll(){
      let listQuery = {
        currpage: 1,
        perpage: 10,
        strorgancode:localStorage.gancode,
        roletype:localStorage.loginRoletype,
        strCustlevel:'', // 客户等级
        strProvince: '', // 省
        strCity: '', // 市
        custname:'', //客户名称
        username:'', //业务员
        depname:'', //业务部门
        groupname:'', //所属集团
        strCustType:'', //客户类别
        strCustindust:'' //客户行业
      }
      xz.getCustLists(listQuery).then(res => {
        // console.log('客户', res)
        if (res.status == 'ok') {
          this.custData = res.msg
        } else {
          this.custData = []
        }
      })
    },
    // 获取客户详情
    getDetailCustData(){
      this.azList = []
      this.depForm.strBusidepList = []
      xz.getCustDetail(this.custQuery.custid).then(res => {
        if (res.status == 'ok') {
          let jsonRes,jsonMsgma
          if(res.msg){
            jsonRes = JSON.parse(res.msg)
            this.industryQuery.strtabletype = 'child'
            this.industryQuery.strtabletypename = jsonRes.strCustTypeid
            this.getIndustryTypeList()
            this.custQuery = {
              custid:jsonRes.Custid,
              strCustShortName: jsonRes.StrCustShortName,
              strCustName: jsonRes.StrCustName, // 客户名称
              strGroupName: jsonRes.StrGroupName, // 所属集团
              strCustlevel: jsonRes.StrCustlevel, // 客户等级
              strCustindust: jsonRes.strCustindustid, // 行业名称
              strCustType: jsonRes.strCustTypeid, // 行业分类
              strProvince: jsonRes.StrProvince, // 省
              strCity: jsonRes.StrCity, // 市
              strRegion: jsonRes.StrRegion // 地区码
            }
            // console.log('88',jsonRes)
            // 匹配省市
            let areaVal = '';
            if(!this.isNull(jsonRes.StrProvince)){
              if(!this.isNull(jsonRes.StrCity)){
                areaVal = jsonRes.StrCity
              }else{
                areaVal = jsonRes.StrProvince
              }
            }else{
              if(!this.isNull(jsonRes.StrCity)){
                areaVal = jsonRes.StrCity
              }
            }
            let posArrVal = this.getParentsByIdCust(
              this.areaList,areaVal
            );
            // console.log('99',posArrVal)
            if(!this.isNull(posArrVal)){
              if(posArrVal.length>1){
                this.selectedCust = [posArrVal[1].Name,posArrVal[0].Name]
              }else if(posArrVal.length==1){
                this.selectedCust = [posArrVal[0].Name]
              }
            }
          }
          if(res.msgma){
            jsonMsgma = JSON.parse(res.msgma)
            // console.log('详情', jsonRes)
            if(jsonMsgma && jsonMsgma.length>0){
              for (let i = 0; i < jsonMsgma.length; i++) {
                const elementMa = jsonMsgma[i]
                this.azList.push(
                  {
                    strorganname: elementMa.Strorganname,
                    strsaleuserid: elementMa.Strsaleuserid,
                    strBusidep: elementMa.StrBusidep,
                    username: elementMa.Username
                  }
                )
              }
            }
          }
        }
      })
    },
    // 项目详情
    getDetailData() {
      this.listLoading = true;
      xz.getProjectDetail(this.proForm.projectid).then(async (res) => {
        // console.log('详情', res)
        if (res.status == "ok") {
          let jsonres = JSON.parse(res.msg);
          let that = this;
          this.proForm = {
            projectid: jsonres.Projectid, //项目id
            strprojectName: jsonres.StrprojectName, //项目名称
            custid: jsonres.Custid, //客户id
            dtInitDate: jsonres.DtInitDate, //立项时间
            strSignsubject: jsonres.StrSignsubject, //签约主体
            strContractType: jsonres.StrContractType, //合同业务类型
            actualtype: jsonres.Actualtype, //业务类型
            strprojectlevel: jsonres.Strprojectlevel, //项目等级
            strProProvince: jsonres.StrProProvince, //省
            strProCity: jsonres.StrProCity, //市
            strbusdep: jsonres.Strbusdep, //业绩归属部门
            // strbussondep: jsonres.Strbussondep, //业绩归属子部门
            strpartner: jsonres.Strpartnername, //业务团队长
            strpartner2: jsonres.Strpartner2name, //合伙人
            strAchieveowner: jsonres.StrAchieveownername, //业绩归属人
            strAchievedep: jsonres.StrAchievedep, //业绩归属人部门
            strservuserid: jsonres.Strservuserid, //客服
            editCusIds: !that.isNull(jsonres.Strservuserid)
              ? jsonres.Strservuserid.split(",")
              : [],
            strProManager: jsonres.StrProManagername, //项目管理员
            strBusiStat: jsonres.StrBusiStat, //项目状态
            strrecruit: jsonres.Strrecruit, //是否招聘
            strTransfer: jsonres.StrTransfer, //是否转移
            strHighRisk: jsonres.StrHighRisk, //协议高风险
            strNewadd: jsonres.StrNewadd, //是否新增
            socialInsurance: jsonres.SocialInsurance, //社保
            busInsurance: jsonres.BusInsurance, //商保
            decRiskfund: jsonres.DecRiskfund, //  风险计提金
            strinvoiceType: jsonres.StrinvoiceType, //开票方式
            strInvoicecontent: jsonres.StrInvoicecontent, //发票内容
            strBillmethod: jsonres.StrBillmethod, // 发票类型
            dtpaydate: jsonres.Dtpaydate, //发薪日期
            isAdvMoney: jsonres.IsAdvMoney, //是否垫资
            dtEndDate: jsonres.DtEndDate, //项目终止时间
            dtContractstartDate: jsonres.DtContractstartDate, //合同开始时间
            dtContractendDate: jsonres.DtContractendDate, //合同结束时间
            strContleader: jsonres.StrContleadername, //合同负责人
            strDep1: jsonres.StrDep1, //部门一级
            strDep2: jsonres.StrDep2, //部门二级
            strDep3: jsonres.StrDep3, //部门三级
            strRegion: jsonres.StrRegion, //地区码
            strViewids: jsonres.StrViewids,
          };
          this.dtlOneQuery = {
            strpartner: jsonres.Strpartner, //业务团队长
            strpartner2: jsonres.Strpartner2, //合伙人
            strAchieveowner: jsonres.StrAchieveowner, //业绩归属人
            strservuserid: jsonres.Strservuserid, //客服
            strProManager: jsonres.StrProManager, //项目管理员
            strContleader: jsonres.StrContleader, //合同负责人
          };
          // 部门
          await this.getDepartList();
          if (jsonres.BusInsurance) {
            this.proForm.busInsuranceList = jsonres.BusInsurance.split(",");
          }
          if (jsonres.SocialInsurance) {
            this.proForm.socialInsuranceList =
              jsonres.SocialInsurance.split(",");
          }
          if (jsonres.StrViewids) {
            this.viewidList = jsonres.StrViewids.split(",");
          }
          this.dedpartNameList = [
            jsonres.StrDep1,
            jsonres.StrDep2,
            jsonres.StrDep3,
          ];
          // 去除空值
          this.dedpartNameList = this.dedpartNameList.filter(function (s) {
            return s && s.trim(); // 注：IE9(不包含IE9)以下的版本没有trim()方法
          });
        }
        this.listLoading = false;
      });
    },
    //判断是否为空(包含0)
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0
      );
    },
    // 客户列表
    getCusList() {
      xz.getCustLists(this.listQuery).then((res) => {
        // console.log('客户', res)
        if (res.status == "ok") {
          this.customList = res.msg;
        } else {
          this.customList = [];
        }
      });
    },
    // 获取项目名称列表
    getProNameList() {
      xz.getProjectLists(this.proNameQuery).then((res) => {
        // console.log('项目名称列表', res)
        if (res.status == "ok") {
          this.proNameList = res.msg;
        } else {
          this.proNameList = [];
        }
      });
    },
    // 获取部门列表
    getDepartList() {
      let perDepartArr = [];
      let perOwnerArr = [];
      // this.perDepartList = []
      // this.perOwnerList = []
      let perLength = 0;
      let ownerLength = 0;
      this.departQuery.strorgancode = "";
      this.departQuery.roletype = "";
      xz.getorganstr(this.departQuery.strorgancode, this.departQuery.roletype, {
        strIsDisable: "1",
      }).then((res) => {
        // console.log('部门', res)
        if (res.status == "ok") {
          if (res.msg && res.msg.parent) {
            this.departList = res.msg.parent[0].children;
          }
          if (this.isEdit != "false") {
            // console.log('详情', this.departList, this.proForm.strbusdep)
            if (this.departList != []) {
              // 业绩归属部门
              perDepartArr = this.getParentsById(
                this.departList,
                this.proForm.strbusdep
              );
              // 业绩归属人部门
              perOwnerArr = this.getParentsById(
                this.departList,
                this.proForm.strAchievedep
              );
              if (perDepartArr != undefined && perDepartArr.length > 0) {
                for (let i = 0; i < perDepartArr.length; i++) {
                  const elementDep = perDepartArr[i];
                  this.perDepartList.push(elementDep.strorgancode);
                }
                this.perDepartList = this.perDepartList.reverse();
              } else {
                this.perDepartList = [];
              }
              if (perOwnerArr != undefined && perOwnerArr.length > 0) {
                for (let j = 0; j < perOwnerArr.length; j++) {
                  const elementDep = perOwnerArr[j];
                  this.perOwnerList.push(elementDep.strorgancode);
                }
                this.perOwnerList = this.perOwnerList.reverse();
              } else {
                this.perOwnerList = [];
              }
              // console.log('部门', this.perDepartList)
            }
          }
        } else {
          this.departList = [];
        }
      });
    },
    // 获取员工列表
    getMemberList(type) {
      xz.getauthUserInfoByorgancode(
        this.memberComQuery
      ).then((res) => {
        // console.log('员工', res)
        if (res.status == "ok") {
          if(type == 'leader'){
          this.leaderList = res.msg;
          }else if(type == 'member'){
          this.memberList = res.msg;
          }else if(type == 'other'){
          // 员工列表
          this.staffList = res.msg;
          }else if(type == 'partner'){
          // 合伙人列表
          this.partnerList = res.msg;
          }else if(type == 'views'){
          // 项目查看人列表
          this.viewsList = res.msg;
          }
        } else {
          if(type == 'leader'){
          // 业务团队长列表
          this.leaderList = [];
          }else if(type == 'member'){
          // 业绩归属人列表
          this.memberList = [];
          }else if(type == 'other'){
          // 员工列表
          this.staffList = [];
          }else if(type == 'partner'){
          // 合伙人列表
          this.partnerList = [];
          }else if(type == 'views'){
          // 项目查看人列表
          this.viewsList = [];
          }
        }
      });
    },
    // 获取客服列表
    getCustomerList(type) {
      xz.getUserInfoBytoporgancode(
        this.departQuery.strorgancode,
        this.departQuery.roletype,
        this.departMemberQuery
      ).then((res) => {
        // console.log('员工', res)
        if (res.status == "ok") {
          if (type == "customer") {
            this.customerList = res.msg;
          } else {
            // 客服列表
            this.customerList = [];
          }
        }
      });
    },
    industryChange(val){
      // console.log('ddd',val)
      this.custQuery.strCustindust = ''
      let obj = {};
      if(!this.isNull(val)){
        obj = this.industryList.find((item)=>{
          return item.Custindustid === val;
        });
        this.custQuery.strCustType = obj.Custindustid
        this.industryQuery.strtabletypename = obj.Custindustid
        this.industryQuery.strtabletype = 'child'
        this.getIndustryTypeList()
      }
    },
    industryNameChange(val){
      this.custQuery.strCustindust = val
    },
    // 获取业务部门列表
    getCustDepartList(){
      xz.getorganstr(this.departCustQuery.strorgancode,this.departCustQuery.roletype,{strIsDisable:'1'}).then(res => {
        // console.log('部门', res)
        if (res.status == 'ok') {
          this.departmentList = res.msg.parent[0].children
        } else {
          this.departmentList = []
        }
      })
    },
    depChange(val){
      // console.log('val', val)
      const checkedNode = this.$refs["cascaderArr"].getCheckedNodes()
      // console.log( checkedNode[0].data.label );  //获取当前点击节点的label值
      // console.log( checkedNode[0].pathLabels);  //获取由label组成的数组
      if(!this.isNull(checkedNode)){
        this.depForm.strorganname = checkedNode[0].pathLabels.join('/')
      }
      this.departMemberQuery.strWorkState = '在职'
      // this.custQuery.strBusidepList[this.custQuery.strBusidepList.length-1]
    },
    salesChange(val){
      let obj = {};
      if(!this.isNull(val)){
        obj = this.salesmanList.find((item)=>{
          return item.Userid === val;
        });
        this.depForm.username = obj.Username
        // this.saveSalesHandle()
      }else{
        this.depForm.username = ''
      }
    },
    // 获取部门员工列表
    getMemberList2(){
      xz.getauthUserInfoByorgancode(this.memberComQuery).then(res => {
        // console.log('员工', res)
        if (res.status == 'ok') {
          this.salesmanList = res.msg
        } else {
          this.salesmanList = []
        }
      })
    },
    // 获取行业列表(类别，名称)
    getIndustryTypeList(){
      xz.getSearchCustindust(this.industryQuery).then(res => {
        // console.log('行业', res)
        if (res.status == 'ok') {
          if(this.industryQuery.strtabletype == 'parent'){
            this.industryList = res.msg
          }else if(this.industryQuery.strtabletype == 'child' && !this.isNull(this.industryQuery.strtabletypename)){
            this.industryNameList = res.msg
          }
        } else{
          if(this.industryQuery.strtabletype == 'parent'){
            this.industryList = []
          }else if(this.industryQuery.strtabletype == 'child' && !this.isNull(this.industryQuery.strtabletypename)){
            this.industryNameList = []
          }
        }
      })
    },
    // 获取参数列表(等级)
    getParamList(type) {
      this.paramQuery.strtableid = type;
      xz.getParameterList(this.paramQuery).then((res) => {
        // console.log('参数', res)
        if (res.status == "ok") {
          // 客户项目等级
          if (type == "JB_base_Custprolevel") {
            this.levelList = res.msg;
          } else if (type == "JB_base_Busitype") {
            // 业务类型
            this.businessList = res.msg;
          } else if (type == "JB_base_Socialsec") {
            // 社保
            this.socialSecurityList = res.msg;
          } else if (type == "JB_base_Busisec") {
            // 商保
            this.insuranceList = res.msg;
          } else if (type == "JB_base_Legalsub") {
            // 签约主体
            this.legalList = res.msg;
          }
        } else {
          if (type == "JB_base_Custprolevel") {
            this.levelList = [];
          } else if (type == "JB_base_Busitype") {
            // 业务类型
            this.businessList = [];
          } else if (type == "JB_base_Socialsec") {
            // 社保
            this.socialSecurityList = [];
          } else if (type == "JB_base_Busisec") {
            // 商保
            this.insuranceList = [];
          } else if (type == "JB_base_Legalsub") {
            // 签约主体
            this.legalList = [];
          }
        }
      });
    },
    //根据id查询该节点和所有父级节点 回显el-cascader组件的值
    getParentsById(list, id) {
      for (let i in list) {
        if (list[i].strorgancode === id) {
          //查询到就返回该数组对象
          return [list[i]];
        }
        if (list[i].children) {
          let node = this.getParentsById(list[i].children, id);
          if (node !== undefined) {
            //查询到把父节点连起来
            return node.concat(list[i]);
          }
        }
      }
    },
    getParentsByIdCust(list, id) {
      for (let i in list) {
        if (list[i].Name === id) {
          //查询到就返回该数组对象
          return [list[i]];
        }
        if (list[i].children) {
          let node = this.getParentsByIdCust(list[i].children, id);
          if (node !== undefined) {
            //查询到把父节点连起来
            return node.concat(list[i]);
          }
        }
      }
    },
    handleClick() {},
    nextStep(){
      // console.log('444',this.custQuery)
      this.nextLoading = true
      this.$refs['custForm'].validate((valid) => {
        if (valid) {
          xz.updatacustomer(this.custQuery).then((res) => {
            if (res.status == "ok") {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.custQuery.custid = res.data
              this.proForm.custid = res.data
              this.activeName = 'second'
              this.isCanChange = false
            } else {
              this.$message({
                message: "保存失败，请稍后再试",
                type: "error",
              });
            }
            this.nextLoading = false
          });
          // 员工
              this.getMemberList("leader");
              this.getMemberList('other')
              this.getMemberList('partner')
              this.getMemberList('member')
              this.getCustomerList("customer");
              this.getMemberList('views')
              // 项目名称列表
              this.getProNameList();
              // 业务类型
              this.getParamList("JB_base_Busitype");
              // 社保
              this.getParamList("JB_base_Socialsec");
              // 商保
              this.getParamList("JB_base_Busisec");
              // 签约主体
              this.getParamList("JB_base_Legalsub");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
};
</script>
<style>
.p_pro_content .p_pro_table .el-input__inner {
  width: 100%;
}
.p_pro_content .p_pro_table .pro-form-inline .el-date-editor.el-input {
  width: 300px;
}
.pro_area .trigger_select {
  height: 40px !important;
}
.pro_area .delete_value {
  top: 12px !important;
}
.p_pro_table .el-date-editor.el-input,
.p_pro_table .el-select,
.p_pro_table .el-cascader .el-input {
  width: 300px;
}
.p_pro_table .el-form--inline .el-form-item__content,
.pro_area .xz_con,
.p_pro_table .el-cascader {
  width: 300px !important;
}
.p_pro_table .xz_tabs li:nth-child(3) {
  display: none;
}
/* .p_pro_table .xz_total_domain div:nth-child(3){
  display: none;
} */
.btnbox{
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
<style scoped>
.p_pro_table {
  padding: 30px 20px;
  background-color: #fff;
}
.el-pagination {
  background-color: #fff;
}
</style>